import React from 'react';
import LifeCycleModal from '../LifeCycleModal';
import { lifeCycleEntitiesMap } from '../../constants/lifeCycle';
import SelectStep from '../SelectStep';
import { useChangeLifeCycleSuccess } from '../../utils/createChangeLifeCycleSuccessHandler';
import { useChangeRoomStep } from '../../../../../mutations/useChangeRoomStep';

const ChangeStepModal = ({ flatsGridKey, room }) => {
  const onSuccess = useChangeLifeCycleSuccess(flatsGridKey);
  const { mutateAsync, isLoading } = useChangeRoomStep({ onSuccess });

  const getOnSubmit = ({ closeModal }) => {
    return async (values) => {
      await mutateAsync(values);
      closeModal();
    };
  };

  return (
    <LifeCycleModal
      getInitialValue={getInitialValue}
      getOnSubmit={getOnSubmit}
      entity={lifeCycleEntitiesMap.step}
      FormComponent={SelectStep}
      confirmLoading={isLoading}
      room={room}
      flatsGridKey={flatsGridKey}
    />
  );
};

export default ChangeStepModal;

function getInitialValue(room, lifeCycleState) {
  return typeof lifeCycleState === 'object'
    ? lifeCycleState?.step?.id
    : room?.addressLifeCycle?.stepAddressLifeCycle?.id;
}
